<template>
  <modal :class="{'hidden': isModalHidden}" :name="modalName" width="100%" height="100%" :clickToClose="false"
         @opened="handleDialogOpened" @closed="hideModal">
    <subscription-plan-view
        viewType="dialog"
        :type="type"
        @showView="isModalHidden = false"
        @onGetQuote="showQuoteModal"
        @closeView="hideModal"
        @freePlanSelected="hideModal"
    />
    <quote-request-modal
      :show="isQuoteModalOpened"
      @onClose="closeQuoteModal"
    />
  </modal>
</template>

<script>

import SubscriptionPlanView from './SubscriptionPlanView.vue';
import QuoteRequestModal from '../quote/QuoteRequestModal.vue';
import { toggleCustomerly } from '../../../teachers/customerly';

export default {
  props: {
    show: Boolean,
    type: String,
    name: String
  },
  components: {
    SubscriptionPlanView,
    QuoteRequestModal
  },
  data: function() {
    return {
      isModalHidden: false,
      isQuoteModalOpened: false
    };
  },
  computed: {
    modalName() {
      return this.name || 'subscription-modal';
    }
  },
  watch: {
    'show'(newVal, oldVal) {
      if (newVal) {
        this.showModal();
      }
    },
  },
  mounted() {
    if (this.type === 'support') {
      this.showModal();
    }
  },
  methods: {
    showModal() {
      this.$modal.show(this.modalName);
    },
    hideModal() {
      if (this.type === 'support') {
        this.$el.classList.add('hidden');
        this.isModalHidden = true;
      } else {
        this.$modal.hide(this.modalName);
        this.$emit('closeDialog');
      }
    },
    handleDialogOpened() {
      if (this.type === 'support' && this.$el && this.$el.classList) {
        this.$el.classList.add('hidden');
        this.isModalHidden = true;
      }
    },
    showQuoteModal() {
      this.isQuoteModalOpened = false;
      toggleCustomerly(false);
      window.open('/get-in-touch?utm_source=in_app&utm_medium=pricing_table&utm_campaign=quote', '_blank');
    },
    closeQuoteModal() {
      this.isQuoteModalOpened = false;
      toggleCustomerly(true);
    }
  },
};
</script>

<style scoped lang="scss">
@import '../common/variables';

.v--modal-overlay[data-modal="subscription-modal"],
.v--modal-overlay[data-modal="custom-subscription-modal"],
.v--modal-overlay[data-modal="navigation-subscription-modal"] {
  z-index: 9999999999;
  ::v-deep(.v--modal-box) {
    padding: 48px 66px 48px;
    background: $light-blue;
    overflow-y: auto;

    @media(max-width: 1250px) {
      padding-bottom: 20px;
      ::v-deep(.plan-view-main) {
        max-height: 560px;
        flex-wrap: wrap;
        overflow-y: auto;

        .subscription-card {
          margin-bottom: 20px;

          &:nth-child(3) {
            margin-right: 0;
          }

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    @media(max-width: 1091px) {
      ::v-deep(.plan-view-main) {
        .subscription-card {
          &:nth-child(2) {
            margin-right: 0;
          }

          &:nth-child(3) {
            margin-right: 20px;
          }

          &:last-child {
            margin-bottom: 20px;
          }
        }
      }
    }

    @media(max-width: 767px) {
      ::v-deep(.plan-view-main) {
        margin: 0 auto;

        .subscription-card {
          margin-right: 0 !important;
        }
      }
    }

    @media (max-width: 600px) {
      ::v-deep(.plan-view-header) {
        .button-close {
          top: -20px;
          right: -20px;
        }
      }
    }
  }
}
</style>
